import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../../../../../helpers/common'
import { register } from '../../../../../../../../helpers/reducerRegistry'
import { convertDataTable, convertDataTableRaw, getListId } from '../helper'
import { downloadLinkageScore, getLinkageScoreThunk } from './thunk'

const initialState = {
  ids: [],
  data: {},
  dataRaw: [],
  idsRaw: [],
  loading: {
    linkageScore: false,
    download: false,
  },
  filter: {
    sortBy: 'relationship',
    sortDirection: 'Ascending',
  },

  //CorporateLinkageScore
  linkageScoreById: {},
}
const slice = createSlice({
  name: 'score/corporateRiskScore/CorporateLinkageScore',
  initialState: initialState,
  reducers: {
    changeFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload }
    },
    changeIds: (state, action) => {
      state.ids = action.payload
    },
    resetStoreLinkage(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLinkageScoreThunk.pending, (state, action) => {
      state.loading.linkageScore = true
    })
    builder.addCase(getLinkageScoreThunk.fulfilled, (state, action) => {
      state.linkageScoreById = keyBy(action.payload, 'organizationId')

      state.ids = getListId(action.payload)
      state.idsRaw = getListId(action.payload)
      state.dataRaw = convertDataTableRaw(action.payload)
      state.data = action.payload ? convertDataTable(action.payload) : {}
      state.loading.linkageScore = false
    })
    builder.addCase(getLinkageScoreThunk.rejected, (state, action) => {
      state.loading.linkageScore = action.payload.loading
    })
    //downloadLinkageScore
    builder.addCase(downloadLinkageScore.pending, (state, action) => {
      state.loading.download = true
    })
    builder.addCase(downloadLinkageScore.fulfilled, (state, action) => {
      state.loading.download = false
    })
    builder.addCase(downloadLinkageScore.rejected, (state, action) => {
      state.loading.download = false
    })
  },
})

export const selectIdsTable = (state) => state[slice.name]?.ids
export const selectIdsRawTable = (state) => state[slice.name]?.idsRaw
export const selectDataRawTable = (state) => state[slice.name]?.dataRaw
export const getDataReduxTable = (rowId, colId) => (state) => {
  return state[slice.name].data[rowId][colId]
}
//loading
export const selectLoadingTable = (state) =>
  state[slice.name]?.loading.linkageScore
export const selectLoadingDownload = (state) =>
  state[slice.name]?.loading.download

export const selectFilter = (state) => state[slice.name].filter

export const selectLinkageScoreById = (rowId, colId) => (state) => {
  const data = state[slice.name].linkageScoreById
  return data[rowId][colId]
}
export const selectLinkageScoreByIdValue = (state) => {
  return state[slice.name].linkageScoreById
}

export const { changeFilter, changeIds, resetStoreLinkage } = slice.actions

register(slice.name, slice.reducer)
